import { isDonationPath } from '@/utils/isDonationPath';

import { TARGET_TYPE_LABEL } from '../../_utils/labels';
import type { LinkFormValue, SearchType } from '../../_utils/links';
import type { PartnersLinkPage } from '../../_utils/types';

const SEARCH_TYPES: SearchType[] = ['MONTHLY_EVENT', 'REGION', 'GIFT_PRODUCT'];

export const SEARCH_LABEL = { ...TARGET_TYPE_LABEL, GIFT_PRODUCT: '답례품' };

export const choiceOptionsOf = (pages: PartnersLinkPage[]) => [
  ...pages
    .filter((page) => isDonationPath(page.pagePath))
    .map((page) => ({
      label: page.pageName,
      value: page.partnersLinkPageId,
    })),
  ...SEARCH_TYPES.map((type) => ({
    label: SEARCH_LABEL[type],
    value: type,
  })),
];

export const searchTypeOf = (choice: string) =>
  SEARCH_TYPES.find((type) => type === choice);

export const EMPTY_FORM: LinkFormValue = {
  choice: '',
  query: '',
  target: null,
  channel: '',
  name: '',
};
